(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-form-picker"] && !Shopify.designMode) return;
  try {
    
  class ArtFormPicker extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]:not([disabled])'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });
    }

    activateTab(selectedTab) {
      const selectedIndex = selectedTab.dataset.tabIndex;

      this.tabs.forEach((tab) => {
        const isSelected = tab.dataset.tabIndex === selectedIndex;
        tab.classList.toggle('art-form-picker__tab--active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isSelected = panel.dataset.tabIndex === selectedIndex;
        panel.classList.toggle('art-form-picker__panel--active', isSelected);
        panel.hidden = !isSelected;
      });
    }

    handleKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      if (index === -1) return;

      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (nextIndex === null) return;

      event.preventDefault();
      this.tabs[nextIndex].focus();
      this.activateTab(this.tabs[nextIndex]);
    }
  }

  if (!customElements.get('art-form-picker')) {
    customElements.define('art-form-picker', ArtFormPicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class ArtFormPicker extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]:not([disabled])'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });

      this.applyArtFromUrl();
    }

    applyArtFromUrl() {
      const art = new URLSearchParams(window.location.search).get('art');
      if (!art) return;

      const match = this.tabs.find((tab) => tab.dataset.artHandle === art);
      if (match) this.activateTab(match);
    }

    activateTab(selectedTab) {
      const selectedIndex = selectedTab.dataset.tabIndex;

      this.tabs.forEach((tab) => {
        const isSelected = tab.dataset.tabIndex === selectedIndex;
        tab.classList.toggle('art-form-picker__tab--active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isSelected = panel.dataset.tabIndex === selectedIndex;
        panel.hidden = !isSelected;
      });
    }

    handleKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      if (index === -1) return;

      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (nextIndex === null) return;

      event.preventDefault();
      this.tabs[nextIndex].focus();
      this.activateTab(this.tabs[nextIndex]);
    }
  }

  if (!customElements.get('art-form-picker')) {
    customElements.define('art-form-picker', ArtFormPicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["group-drop"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.group-drop__form').forEach((form) => {
    if (form.dataset.qtyBound) return;
    form.dataset.qtyBound = 'true';
    const input = form.querySelector('input[name="quantity"]');
    if (!input) return;
    form.querySelectorAll('[data-qty-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.qtyChange || 0);
        const next = Math.max(1, (Number(input.value) || 1) + delta);
        input.value = String(next);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  class ArtFormPicker extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]:not([disabled])'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });

      this.applyArtFromUrl();
    }

    applyArtFromUrl() {
      const art = new URLSearchParams(window.location.search).get('art');
      if (!art) return;

      const match = this.tabs.find((tab) => tab.dataset.artHandle === art);
      if (match) this.activateTab(match);
    }

    activateTab(selectedTab) {
      const selectedIndex = selectedTab.dataset.tabIndex;

      this.tabs.forEach((tab) => {
        const isSelected = tab.dataset.tabIndex === selectedIndex;
        tab.classList.toggle('art-form-picker__tab--active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isSelected = panel.dataset.tabIndex === selectedIndex;
        panel.hidden = !isSelected;
      });
    }

    handleKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      if (index === -1) return;

      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (nextIndex === null) return;

      event.preventDefault();
      this.tabs[nextIndex].focus();
      this.activateTab(this.tabs[nextIndex]);
    }
  }

  if (!customElements.get('art-form-picker')) {
    customElements.define('art-form-picker', ArtFormPicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
